import ProfilesRoute from './ProfilesRoute';

export { studentInterestOptions, teacherPositionOptions } from './constants';

export default {
  name: 'ProfilesRoute',
  location: '/lsp/user',
  component: ProfilesRoute,
};
